
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//Material Design Css import
import { MatButtonModule, MatCheckboxModule } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
//Material Design Css import


import { AppComponent } from './khb.component';
import { HeaderComponent } from './common/header/header.component';
import { Level1menuComponent } from './common/level1menu/level1menu.component';
import { UltilitiesComponent } from './ultilities/ultilities.component';
import { UltilitiesMenuComponent } from './ultilities/ultilities-menu/ultilities-menu.component';
import { UserComponent } from './ultilities/user/user.component';
import { SearchbarComponent } from './common/searchbar/searchbar.component';
import { RolesComponent } from './ultilities/roles/roles.component';
import { RolesGridComponent } from './ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './ultilities/roles/roles-form/roles-form.component';
import { UserService } from './shared/user.service';
import { HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './registration/login/login.component';
import { SignupComponent } from './registration/signup/signup.component';
import { UserGridComponent } from './ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './ultilities/user/user-form/user-form.component';
import { ClaimGridComponent } from './ultilities/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './ultilities/claims/claim-form/claim-form.component';
import { ClaimsComponent } from './ultilities/claims/claims.component';
import { RegistrationComponent } from './registration/registration.component';
import { ErrorHandler } from './shared/ErrorHandler';
import { DataTablesModule } from 'angular-datatables';

import { NgxPaginationModule } from 'ngx-pagination';

import { appRoutes } from '../route';
import { HomepageComponent } from './homepage/homepage.component';
import { AuthGuard } from './auth/auth.guard';
import { ChangePasswordComponent } from './ultilities/change-password/change-password.component';
import { ForgotPasswordComponent } from './registration/forgot-password/forgot-password.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FooterComponent } from './common/footer/footer.component';
import { LeadComponent } from './Pages/lead/lead.component';
import { LeadFormComponent } from './Pages/Lead/lead-form/lead-form.component';
import { LeadGridComponent } from './Pages/Lead/lead-grid/lead-grid.component';
import { ActivityGridComponent } from './Pages/activities/activity-grid/activity-grid.component';
import { ActivityFormComponent } from './Pages/activities/activity-form/activity-form.component';
import { ActivitiesComponent } from './Pages/activities/activities.component';
import { ReportsComponent } from './Pages/reports/reports.component';
import { ReportFormComponent } from './Pages/reports/report-form/report-form.component';
import { ReportGridComponent } from './Pages/reports/report-grid/report-grid.component';
import { SalesOrderFormComponent } from './Pages/sales-orders/sales-order-form/sales-order-form.component';
import { SalesOrderGridComponent } from './Pages/sales-orders/sales-order-grid/sales-order-grid.component';
import { SalesOrdersComponent } from './Pages/sales-orders/sales-orders.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AssignLeadGridComponent } from './Pages/lead/assign-leads/assign-lead-grid/assign-lead-grid.component';
import { CompanyProfileGridComponent } from './ultilities/company-profile/company-profile-grid/company-profile-grid.component';
import { CompanyProfileFormComponent } from './ultilities/company-profile/company-profile-form/company-profile-form.component';
import { DivisionDeptFormComponent } from './ultilities/division-department/division-dept-form/division-dept-form.component';
import { DivisionDeptGridComponent } from './ultilities/division-department/division-dept-grid/division-dept-grid.component';
import { EmpMasterGridComponent } from './ultilities/employee-master/emp-master-grid/emp-master-grid.component';
import { EmpMasterFormComponent } from './ultilities/employee-master/emp-master-form/emp-master-form.component';
import { VenderFromComponent } from './Pages/manage/vender/vender-from/vender-from.component';
import { VenderGridComponent } from './Pages/Manage/vender/vender-grid/vender-grid.component';
import { ProductGridComponent } from './Pages/Manage/products/product-grid/product-grid.component';
import { ProductFormComponent } from './Pages/Manage/products/product-form/product-form.component';
import { ManageComponent } from './Pages/manage/manage.component';
import { SalseQuotationGridComponent } from './Pages/sales-orders/sales-quotation/salse-quotation-grid/salse-quotation-grid.component';
import { SalseQuotationFormComponent } from './Pages/sales-orders/sales-quotation/salse-quotation-form/salse-quotation-form.component';
import { PerformaInvoiceFormComponent } from './Pages/sales-orders/performa-invoice/performa-invoice-form/performa-invoice-form.component';
import { PerformaInvoiceGridComponent } from './Pages/sales-orders/performa-invoice/performa-invoice-grid/performa-invoice-grid.component';
import { SalesDeliveryChallanGridComponent } from './Pages/sales-orders/sales-delivery-challan/sales-delivery-challan-grid/sales-delivery-challan-grid.component';
import { SalesDeliveryChallanFormComponent } from './Pages/sales-orders/sales-delivery-challan/sales-delivery-challan-form/sales-delivery-challan-form.component';
import { TaxInvoiceFormComponent } from './Pages/sales-orders/tax-invoice/tax-invoice-form/tax-invoice-form.component';
import { TaxInvoiceGridComponent } from './Pages/sales-orders/tax-invoice/tax-invoice-grid/tax-invoice-grid.component';
import { TaxInvoiceRetailGridComponent } from './Pages/sales-orders/tax-invoice-retail/tax-invoice-retail-grid/tax-invoice-retail-grid.component';
import { TaxInvoiceRetailFormComponent } from './Pages/sales-orders/tax-invoice-retail/tax-invoice-retail-form/tax-invoice-retail-form.component';
import { ReceiptConfirmationGridComponent } from './Pages/sales-orders/receipt-confirmation/receipt-confirmation-grid/receipt-confirmation-grid.component';
import { ReceiptConfirmationFormComponent } from './Pages/sales-orders/receipt-confirmation/receipt-confirmation-form/receipt-confirmation-form.component';
import { PurchaseComponent } from './Pages/purchase/purchase.component';
import { PurchaseQuotationFormComponent } from './Pages/purchase/purchase-quotation/purchase-quotation-form/purchase-quotation-form.component';
import { PurchaseQuotationGridComponent } from './Pages/purchase/purchase-quotation/purchase-quotation-grid/purchase-quotation-grid.component';
import { QuotationComparisonGridComponent } from './Pages/purchase/quotation-comparison/quotation-comparison-grid/quotation-comparison-grid.component';
import { QuotationComparisonFormComponent } from './Pages/purchase/quotation-comparison/quotation-comparison-form/quotation-comparison-form.component';
import { QuotationApprovalFormComponent } from './Pages/purchase/quotation-approval/quotation-approval-form/quotation-approval-form.component';
import { QuotationApprovalGridComponent } from './Pages/purchase/quotation-approval/quotation-approval-grid/quotation-approval-grid.component';
import { PurchaseOrderGridComponent } from './Pages/purchase/purchase-order/purchase-order-grid/purchase-order-grid.component';
import { PurchaseOrderFormComponent } from './Pages/purchase/purchase-order/purchase-order-form/purchase-order-form.component';
import { QdChallanFormComponent } from './Pages/purchase/quotation-delivery-challan/qd-challan-form/qd-challan-form.component';
import { QdChallanGridComponent } from './Pages/purchase/quotation-delivery-challan/qd-challan-grid/qd-challan-grid.component';
import { MrNoteGridComponent } from './Pages/purchase/material-receipt-note/mr-note-grid/mr-note-grid.component';
import { MrNoteFormComponent } from './Pages/purchase/material-receipt-note/mr-note-form/mr-note-form.component';
import { MrnApprovalFormComponent } from './Pages/purchase/mrn-approval/mrn-approval-form/mrn-approval-form.component';
import { MrnApprovalGridComponent } from './Pages/purchase/mrn-approval/mrn-approval-grid/mrn-approval-grid.component';
import { ArPaymentGridComponent } from './Pages/purchase/account-receivable-payment/ar-payment-grid/ar-payment-grid.component';
import { ArPaymentFormComponent } from './Pages/purchase/account-receivable-payment/ar-payment-form/ar-payment-form.component';
import { ArReceiptGridComponent } from './Pages/sales-orders/accounts-receivable-receipt/ar-receipt-grid/ar-receipt-grid.component';
import { ArReceiptFormComponent } from './Pages/sales-orders/accounts-receivable-receipt/ar-receipt-form/ar-receipt-form.component';
import { PaymentApprovalFormComponent } from './Pages/purchase/payment-approval/payment-approval-form/payment-approval-form.component';
import { PaymentApprovalGridComponent } from './Pages/purchase/payment-approval/payment-approval-grid/payment-approval-grid.component';
import { ProductViewComponent } from './pages/manage/products/product-view/product-view.component';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ProfileComponent } from './Pages/user/profile/profile.component';
import { FeedbackComponent } from './Pages/User/feedback/feedback.component';
import { ArReceiptViewComponent } from './Pages/sales-orders/accounts-receivable-receipt/ar-receipt-view/ar-receipt-view.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    Level1menuComponent,
    LoginComponent,
    UltilitiesComponent,
    UltilitiesMenuComponent,
    UserComponent,
    SearchbarComponent,
    RolesComponent,
    RolesGridComponent,
    RolesFormComponent,
    SignupComponent,
    UserGridComponent,
    UserFormComponent,
    ClaimGridComponent,
    ClaimFormComponent,
    ClaimsComponent,
    RegistrationComponent,
    ForgotPasswordComponent,
    HomepageComponent,
    ChangePasswordComponent,
    FooterComponent,
    LeadComponent,
    LeadFormComponent,
    LeadGridComponent,
    ActivityGridComponent,
    ActivityFormComponent,
    ActivitiesComponent,
    ReportsComponent,
    ReportFormComponent,
    ReportGridComponent,
    SalesOrderFormComponent,
    SalesOrderGridComponent,
    SalesOrdersComponent,
    AssignLeadGridComponent,
    CompanyProfileGridComponent,
    CompanyProfileFormComponent,
    DivisionDeptFormComponent,
    DivisionDeptGridComponent,
    EmpMasterGridComponent,
    EmpMasterFormComponent,
    VenderFromComponent,
    VenderGridComponent,
    ProductGridComponent,
    ProductFormComponent,
    ManageComponent,
    SalseQuotationGridComponent,
    SalseQuotationFormComponent,
    PerformaInvoiceFormComponent,
    PerformaInvoiceGridComponent,
    SalesDeliveryChallanGridComponent,
    SalesDeliveryChallanFormComponent,
    TaxInvoiceFormComponent,
    TaxInvoiceGridComponent,
    TaxInvoiceRetailGridComponent,
    TaxInvoiceRetailFormComponent,
    ReceiptConfirmationGridComponent,
    ReceiptConfirmationFormComponent,
    PurchaseComponent,
    PurchaseQuotationFormComponent,
    PurchaseQuotationGridComponent,
    QuotationComparisonGridComponent,
    QuotationComparisonFormComponent,
    QuotationApprovalFormComponent,
    QuotationApprovalGridComponent,
    PurchaseOrderGridComponent,
    PurchaseOrderFormComponent,
    QdChallanFormComponent,
    QdChallanGridComponent,
    MrNoteGridComponent,
    MrNoteFormComponent,
    MrnApprovalFormComponent,
    MrnApprovalGridComponent,
    ArPaymentGridComponent,
    ArPaymentFormComponent,
    ArReceiptGridComponent,
    ArReceiptFormComponent,
    PaymentApprovalFormComponent,
    PaymentApprovalGridComponent,
    ProductViewComponent,
    ProfileComponent,
    FeedbackComponent,
    ArReceiptViewComponent

  ],
  imports: [
    BsDropdownModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    //mat
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    //end    

    DataTablesModule,    
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    
    HttpClientModule,
    RouterModule.forRoot(appRoutes),
  ],
  providers: [UserService, ErrorHandler, AuthGuard, { provide: LocationStrategy, useClass: HashLocationStrategy },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { } 



// WEBPACK FOOTER //
// ./src/app/khb.module.ts